import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import { isEmpty } from 'lodash';

import { t } from '../../../../../../modules/infra/i18n';
import RouterTabs from '../../../../../common/RouterTabs';
import MatchesActions from './MatchesActions';
import shopifyIcon from '../../../../../../../images/shopifyIcon.png';
import {
  SHOPIFY_SETTINGS,
} from '../../../../../main/settings/integrations/constants';
import { PRODUCTS_SHOPIFY_PATH } from '../../constants';

const ManageShopifyMatches = (
  {
    baseUrl,
    dismissable,
    linkable,
    loadingMatches,
    restorable,
    children,
    matchesInitialized,
    onArchive,
    onLink,
    onRestore,
    selectedItems,
  }
) => {
  const hasItemsSelected = !isEmpty(selectedItems);

  return (
    <div className="manage-shopify-matches c-inner-wrapper-left u-mt u-ml">
      <RouterTabs disabled={!matchesInitialized} baseName={`${baseUrl}${PRODUCTS_SHOPIFY_PATH}`}>
        <div path="matches">
          <img alt={t('products:shopify.shopify_icon_alt')} src={shopifyIcon} />
          {t('products:shopify.sku_matches_tab')}
        </div>
        <div path="dismissed">
          {t('products:shopify.dismissed_tab')}
        </div>
        <div path="linked">
          {t('products:shopify.linked_products_tab')}
        </div>
      </RouterTabs>
      <div className="actions-right">
        <Link
          disabled={loadingMatches}
          to={`${baseUrl}${SHOPIFY_SETTINGS}`}
          className="c-btn c-btn--grey u-mr-- c-btn--medium u-mr0"
        >
          <span className="c-btn__text">{t('products:shopify.shopify_settings_button')}</span>
        </Link>
        <MatchesActions
          dismissable={dismissable}
          restorable={restorable}
          display-if={!linkable}
          hasItemsSelected={hasItemsSelected}
          onDismiss={onArchive}
          onLink={onLink}
          onRestore={onRestore}
        />
      </div>
      {children}
    </div>
  );
};

ManageShopifyMatches.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  dismissable: PropTypes.bool,
  linkable: PropTypes.bool,
  loadingMatches: PropTypes.bool.isRequired,
  restorable: PropTypes.bool,
  children: PropTypes.node.isRequired,
  matchesInitialized: PropTypes.bool.isRequired,
  onArchive: PropTypes.func.isRequired,
  onLink: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
};

ManageShopifyMatches.defaultProps = {
  dismissable: false,
  linkable: false,
  restorable: false,
};

export default ManageShopifyMatches;
